import { splitName } from 'utils/helpers';
import useAccountStore from '../store/accountStore';

const useGetUserData = () => {
  const { account } = useAccountStore();
  const { displayName, email, avatar } = account;
  const { firstName, lastName } = displayName ? splitName(displayName) : { firstName: '', lastName: '' };
  return {
    displayName, firstName, lastName, email, avatar,
  };
};

export default useGetUserData;
